import ProductTopSlider from "./product-top-slider";

export default ProductTopSlider;